import React from 'react';
import Icon from './Icon';

/** EmptyState — icon, title, body, optional action node. */
export default function EmptyState({ icon = 'circle-help', title, body, action, className = '' }) {
  return (
    <div className={`empty${className ? ` ${className}` : ''}`} role="status">
      <span className="empty__icon"><Icon name={icon} size={26} /></span>
      {title && <div className="empty__title">{title}</div>}
      {body && <p className="empty__body">{body}</p>}
      {action && <div className="empty__action">{action}</div>}
    </div>
  );
}
